import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const testimonials = [
  {
    name: "Carlos Mendoza",
    role: "Dueño de Cafetería 'El Grano'",
    content:
      "Antes perdía dinero todos los días y no sabía por qué. La calculadora de QvaPOS me abrió los ojos, y el sistema me ayudó a recuperar un 15% de margen en el primer mes.",
    rating: 5,
  },
  {
    name: "Ana Lucía Rivas",
    role: "Gerente, Boutique Moda",
    content:
      "La facilidad de uso es increíble. Mis empleados aprendieron a usarlo en 10 minutos. El control de inventario es lo que siempre soñé.",
    rating: 5,
  },
  {
    name: "Roberto Gómez",
    role: "Minimarket Express",
    content:
      "El soporte es excelente y la función offline me ha salvado varias veces. Es la mejor inversión que he hecho para mi negocio.",
    rating: 4,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-12 sm:py-16 md:py-20 lg:py-24 bg-slate-50 dark:bg-slate-900 border-y border-slate-200 dark:border-slate-800"
    >
      <div className="container px-4 mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 sm:mb-10 md:mb-12 lg:mb-16 font-display tracking-tight">
          Lo que dicen nuestros clientes
        </h2>

        <div className="max-w-4xl mx-auto">
          <Carousel
            opts={{
              align: "center",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {testimonials.map((testimonial, index) => (
                <CarouselItem
                  key={index}
                  className="sm:basis-full md:basis-1/2 lg:basis-1/2 p-2"
                >
                  <div className="p-1 h-full">
                    <Card className="h-full shadow-sm hover:shadow-md transition-shadow border-none bg-white dark:bg-slate-800/50 backdrop-blur-sm">
                      <CardContent className="flex flex-col justify-between p-4 sm:p-5 md:p-6 h-full">
                        <div>
                          <div className="flex gap-1 mb-3 sm:mb-4">
                            {[...Array(5)].map((_, i) => (
                              <Star
                                key={i}
                                className={`w-3 h-3 sm:w-4 sm:h-4 ${i < testimonial.rating ? "fill-yellow-400 text-yellow-400" : "fill-gray-200 text-gray-200"}`}
                              />
                            ))}
                          </div>
                          <p className="text-sm sm:text-base text-slate-700 dark:text-slate-300 italic mb-4 sm:mb-5 md:mb-6 leading-relaxed">
                            "{testimonial.content}"
                          </p>
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 mt-auto">
                          <div className="w-8 h-8 sm:w-9 md:w-10 sm:h-9 md:h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm sm:text-base">
                            {testimonial.name[0]}
                          </div>
                          <div>
                            <p className="font-semibold text-xs sm:text-sm text-slate-900 dark:text-white">
                              {testimonial.name}
                            </p>
                            <p className="text-[10px] sm:text-xs text-muted-foreground">
                              {testimonial.role}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden sm:flex -left-8 sm:-left-10 md:-left-12" />
            <CarouselNext className="hidden sm:flex -right-8 sm:-right-10 md:-right-12" />
          </Carousel>
        </div>

        {/* Indicadores para móvil */}
        <div className="flex justify-center gap-2 mt-6 sm:hidden">
          {testimonials.map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600"
              aria-label={`Testimonio ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
